export default "__VITE_ASSET__eQc$fDLH__"